import { Button, TextField, Theme, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { IStore } from "../store";
import { AuthActions } from "../store/auth/auth-actions";
import StoreModel, { LoadedSingleResource } from "../store/StoreModel";
import { mockTheme, WithActions, toMap } from "../utils/utils";
import { ConfigActions, IConfigStore } from "../store/config";
import { bindActionCreators, Dispatch } from "redux";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      textAlign: "center",
      paddingTop: theme.spacing.unit * 20,
    },
    textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
    },
    container: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto",
    },
    loginButton: {
      marginTop: 40,
    },
    message: {
      marginTop: 10,
    },
  });

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface LoginProps
  extends WithStyles<keyof typeof classesType>,
    WithActions<AuthActions> {
  config: IConfigStore;
  configActions: ConfigActions;
  request: LoadedSingleResource;
}

interface LoginState {
  name: string;
  password: string;
}

class BaseLogin extends React.Component<LoginProps, LoginState> {
  constructor(props: LoginProps) {
    super(props);
    console.log(props.config);
    this.state = {
      name: props.config.debug ? "" : "",
      password: props.config.debug ? "" : "",
    };
  }

  handleSubmit = (event: any) => {
    event.preventDefault();
    this.props.actions.login(this.state.name, this.state.password);
  };

  handleChange = (name: "name" | "password") => (event: any) => {
    this.setState({
      ...this.state,
      [name]: event.target.value,
    });
  };

  render() {
    const { classes, config } = this.props;

    return (
      <div className={classes.root}>
        <Typography variant="display1" gutterBottom>
          Taxio
        </Typography>
        <Typography variant="subheading" gutterBottom>
          Bienvenido a <b>{config.data.name}</b> Admin
        </Typography>
        <form
          className={classes.container}
          noValidate
          autoComplete="off"
          onSubmit={this.handleSubmit}
        >
          <TextField
            id="name"
            label="Usuario"
            className={classes.textField}
            value={this.state.name}
            onChange={this.handleChange("name")}
            fullWidth
            margin="normal"
          />
          <TextField
            id="password"
            fullWidth
            label="Contraseña"
            type="password"
            className={classes.textField}
            value={this.state.password}
            onChange={this.handleChange("password")}
            margin="normal"
          />
          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={StoreModel.isLoading(this.props.request)}
            className={classes.loginButton}
            color="primary"
          >
            Iniciar sesión
          </Button>
        </form>
        {/* <Typography variant="caption" className={classes.message}>
                    Este es un portal para administración, si eres usuario de taxio,
                    ve a <a href="https://taxio.cosmesfot.com.py">a la página principal</a>
                </Typography>
                <div>
                    <br />
                    <Typography variant="caption" className={classes.message}>
                        Otras versiones de taxio
                    </Typography>
                    {config.availables.filter(c => c !== config.active).map(c => {
                        return (
                            <Button key={c}
                                onClick={ev => { this.props.configActions.change(c) }}
                                color="secondary">
                                {c}
                            </Button>
                        )
                    })}

                </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: LoginProps): LoginProps => ({
  ...ownProps,
  request: state.auth.request,
  config: state.config,
});

export default compose<any, Partial<LoginProps>>(
  withStyles(styles),
  connect(mapStateToProps, (dispatch: Dispatch) => ({
    actions: bindActionCreators(toMap(AuthActions), dispatch),
    configActions: bindActionCreators(toMap(ConfigActions), dispatch),
  }))
)(BaseLogin);



// WEBPACK FOOTER //
// ./src/pages/login.tsx